/**
 * @MAIN 
 * @LIGHT - 1 shade down
 * @DARK  - 6 shades up
 * 
 * https://coolors.co/
 * 
 */

export const COLOR_MAIN_BLUE_LIGHT          = "#5567F1"
export const COLOR_MAIN_BLUE                = "#364DEF"
export const COLOR_MAIN_BLUE_DARK           = "#0E20AA"


export const COLOR_MAIN_RED_LIGHT           = "#E64337"
export const COLOR_MAIN_RED                 = "#B62116"
export const COLOR_MAIN_RED_DARK            = "#911A12"

export const COLOR_MAIN_GRAY                = "#8B8B8B"
export const COLOR_LIGHT_GRAY               = "#ABABAB"

export const COLOR_MAIN_GREEN_LIGHT         = "#11BB69"
export const COLOR_MAIN_GREEN               = "#0E9554"
export const COLOR_MAIN_GREEN_DARK          = "#0A703F"

export const COLOR_MAIN_WARNING_LIGHT       ="#F7D978"
export const COLOR_MAIN_WARNING             = "#F5CF53"
export const COLOR_MAIN_WARNING_DARK        = "#E7B40D"